import { combineReducers } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import restaurantReducer from './restaurantSlice';
import menuReducer from './menuSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  restaurant: restaurantReducer,
  menu: menuReducer,
});

export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
